import { t } from 'ttag'

export const getColumns = departmentName => [
  {
    header: `${departmentName} ${t`jobs`}`,
    accessorKey: 'name',
    width: '100%',
  },
]
